var _polygon, _polygon2, _polygon3, _polygon4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _line, _rect9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScan = function SvgScan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-2.5 -1.75 54.75 45.625",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "-0.125,13.25 1.437,13.25 1.437,1.53 13.157,1.53 13.157,-0.032 -0.125,-0.032  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "36.596,-0.032 36.596,1.53 48.312,1.53 48.312,13.25 49.875,13.25 49.875,-0.032  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "1.437,28.875 -0.125,28.875 -0.125,42.157 13.157,42.157 13.157,40.595 1.437,40.595  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "48.312,40.595 36.596,40.595 36.596,42.157 49.875,42.157 49.875,28.875 48.312,28.875  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.563,
    y: 6.999,
    width: 1.562,
    height: 28.127
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.032,
    y: 6.999,
    width: 1.562,
    height: 28.127
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 6.999,
    width: 1.562,
    height: 28.127
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.97,
    y: 6.999,
    width: 1.562,
    height: 28.127
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.438,
    y: 6.999,
    width: 1.562,
    height: 28.127
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.907,
    y: 6.999,
    width: 1.562,
    height: 28.127
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.375,
    y: 6.999,
    width: 1.562,
    height: 28.127
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42.844,
    y: 6.999,
    width: 1.562,
    height: 28.127
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.804,
    y1: 21.062,
    x2: 47.947,
    y2: 21.062
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1.804,
    y: 20.562,
    width: 46.144,
    height: 1
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scan.1d49094f.svg";
export { ForwardRef as ReactComponent };